import { createHttpEndpoint } from '../../utils'

import type { GetDocwebsiteCategories } from '.'

/**
 * Get the Doc website categories.
 *
 * @see {@link https://devportal.backmarket.io/catalog/default/api/seller-merchants-api/definition#tag}
 */
export const getDocwebsiteCategories =
  createHttpEndpoint<GetDocwebsiteCategories>({
    method: 'GET',
    operationId: 'getManualRefunds',
    path: '/bm/docwebsite/category/tree',
    transformResponseToCamelCase: true,
  })
